import { TableButton } from '@ipfabric/ui-components/TableButton/TableButton';
import type { WriteScopes } from './useWriteScopes';

type PolicyRowActionsProps = {
  id: string;
  testIdPrefix: string;
  readOnly: boolean;
  scopes: WriteScopes;
  onView: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
};

/**
 * Edit / duplicate / delete, each shown only with its API scope. Built-in
 * (system) rows, and rows the user cannot edit, open read-only instead.
 */
export const PolicyRowActions = ({
  id,
  testIdPrefix,
  readOnly,
  scopes,
  onView,
  onEdit,
  onDuplicate,
  onDelete,
}: PolicyRowActionsProps) => (
  <div className='flex flex-row items-center gap-xs'>
    {readOnly || !scopes.canEdit ? (
      <TableButton
        dataTestId={`${testIdPrefix}-view-${id}`}
        icon='fa-eye'
        onClick={onView}
        size='default'
        type='button'
        variant='plain'
      />
    ) : (
      <TableButton
        dataTestId={`${testIdPrefix}-edit-${id}`}
        icon='fa-pen'
        onClick={onEdit}
        size='default'
        type='button'
        variant='plain'
      />
    )}
    {!readOnly && scopes.canCreate && (
      <TableButton
        dataTestId={`${testIdPrefix}-duplicate-${id}`}
        icon='fa-copy'
        onClick={onDuplicate}
        size='default'
        type='button'
        variant='plain'
      />
    )}
    {!readOnly && scopes.canDelete && (
      <TableButton
        accent='negative'
        dataTestId={`${testIdPrefix}-delete-${id}`}
        icon='fa-trash-can'
        onClick={onDelete}
        size='default'
        type='button'
        variant='plain'
      />
    )}
  </div>
);
